module.exports = __webpack_public_path__ + "static/media/event-5.f9d2c905.jpg";